import { Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';
import React, { useState } from 'react';
import { Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { MAPPINGTYPE } from '../../constants/selects';
import useRegisterMapping from '../../hooks/mapping/useRegisterMapping';
import useUpdateMapping from '../../hooks/mapping/useUpdateMapping';
import { ApplicationState } from '../../store';
import ActivityIndicator from '../ActivityIndicator';
import FooterForm from '../FooterForm';
import './styles.scss';
import reorderBodyMapping from './validation';

interface Props {
  distributorId: string;
}
const FormMapping: React.FC<Props> = ({ distributorId }) => {
  const { execute: executeRegister, loading: loadingRegister } =
    useRegisterMapping();

  const { execute: executeUpdate, loading: loadingUpdate } = useUpdateMapping();
  const { name, fieldsToParse, mappingId } = useSelector(
    (state: ApplicationState) => state.mapping,
  );

  const [mapping, setMapping] = useState({
    ...fieldsToParse,
    name,
    mappingType: 'by_name',
  });

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const body = reorderBodyMapping(mapping);

    if (mappingId.length) {
      await executeUpdate(distributorId, mappingId, body);
    } else {
      await executeRegister(distributorId, body);
    }
  };

  if (loadingUpdate || loadingRegister) {
    return <ActivityIndicator />;
  }

  return (
    <div className="container-form-companie">
      <Form onSubmit={(event: React.FormEvent) => handleSubmit(event)}>
        <header className="information">
          {!mappingId && <Alert severity="warning">
            Em cada campo abaixo você deve digitar o nome de cada coluna que
            está no arquivo fornecido pela <strong>distribuidora</strong> !
          </Alert>}
        </header>
        <Col className="col-mapping container-body">
          <h4>Mapeamento</h4>
          <div className="container-form">
            <Form.Label className="margin-in-form width-form">
              Ordenar Por
            </Form.Label>
            <Form.Label className="width-form">Nome do Mapeamento</Form.Label>
            <Form.Label className="margin-in-form width-form">
              Número da Carga
            </Form.Label>
          </div>
          <div className="container-form">
            <Form.Control
              as="select"
              defaultValue={mapping.mappingType}
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                setMapping({
                  ...mapping,
                  mappingType: event.target.value,
                })
              }
              className="margin-in-form"
            >
              {MAPPINGTYPE.map((option, index) => (
                <option value={option.value} key={index}>
                  {option.name}
                </option>
              ))}
            </Form.Control>

            <Form.Control
              value={mapping.name}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  name: event.target.value,
                })
              }
              required
              className="margin-in-form"
              maxLength={20}
            />
            <Form.Control
              value={mapping.numberCargo}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  numberCargo: event.target.value,
                })
              }
              className="margin-in-form"
              required
              maxLength={20}
            />
          </div>
          <div className="container-form">
            <Form.Label className="width-form">Código da Ordem</Form.Label>
          </div>
          <div className="container-form">
            <Form.Control
              value={mapping.orderCode}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  orderCode: event.target.value,
                })
              }
              required
              maxLength={20}
            />
          </div>
          <h4>Destino</h4>
          <div className="container-form">
            <Form.Label className="margin-in-form width-form">
              Endereço
            </Form.Label>
            <Form.Label className="width-form">Complemento</Form.Label>
          </div>
          <div className="container-form">
            <Form.Control
              value={mapping.address}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  address: event.target.value,
                })
              }
              className="margin-in-form"
              maxLength={20}
            />
            <Form.Control
              value={mapping.address2}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  address2: event.target.value,
                })
              }
              maxLength={20}
            />
          </div>
          <div className="container-form">
            <Form.Label className="margin-in-form width-form">
              Latitude
            </Form.Label>
            <Form.Label className="width-form">Longitude</Form.Label>
          </div>
          <div className="container-form">
            <Form.Control
              value={mapping.latitude}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  latitude: event.target.value,
                })
              }
              className="margin-in-form"
              maxLength={20}
            />

            <Form.Control
              value={mapping.longitude}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  longitude: event.target.value,
                })
              }
              maxLength={20}
            />
          </div>
          <div>
            <Form.Label>Cep</Form.Label>
            <Form.Control
              value={mapping.cep}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  cep: event.target.value,
                })
              }
              className="form-control-mapping"
              required
              maxLength={20}
            />
          </div>

          <h4>Dados complementares</h4>
          <div className="container-form">
            <Form.Label className="margin-in-form width-form">Peso</Form.Label>
            <Form.Label className="width-form">
              Unidade do Peso{` `}
              <Tooltip title="nome da coluna que contém a unidade de peso">
                <InfoOutlined color="disabled" />
              </Tooltip>
            </Form.Label>
          </div>
          <div className="container-form">
            <Form.Control
              value={mapping.weight}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  weight: event.target.value,
                })
              }
              className="margin-in-form"
              maxLength={20}
            />

            <Form.Control
              className="margin-in-form"
              value={mapping.weightUnity}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  weightUnity: event.target.value,
                })
              }
              maxLength={20}
            />
          </div>
          <div className="container-form">
            <Form.Label className="margin-in-form width-form">
              Nota Fiscal
            </Form.Label>
            <Form.Label className="width-form">Valor da Mercadoria</Form.Label>
          </div>
          <div className="container-form">
            <Form.Control
              value={mapping.nf}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  nf: event.target.value,
                })
              }
              className="margin-in-form"
              required
              maxLength={20}
            />
            <Form.Control
              value={mapping.price}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  price: event.target.value,
                })
              }
              required
              maxLength={20}
            />
          </div>

          <div className="container-form">
            <Form.Label className="margin-in-form width-form">
              Nome Fantasia{' '}
              <Tooltip title="se não existir utilizar a coluna de nome corporativo">
                <InfoOutlined color="disabled" />
              </Tooltip>
            </Form.Label>
            <Form.Label className="width-form">Nome Corporativo</Form.Label>
          </div>
          <div className="container-form">
            <Form.Control
              value={mapping.fantasyName}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  fantasyName: event.target.value,
                })
              }
              className="margin-in-form"
              required
              maxLength={20}
            />

            <Form.Control
              value={mapping.corporateName}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setMapping({
                  ...mapping,
                  corporateName: event.target.value,
                })
              }
              required
              maxLength={20}
            />
          </div>
        </Col>
        <FooterForm id={mappingId} />
      </Form>
    </div>
  );
};

export default FormMapping;
